module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_17_L_2.d8bf2deb.mp3";